import React from 'react';
import { Tooltip, Box } from '@chakra-ui/react';

interface BadgeWithTooltipProps {
  icon: string;
  alt: string;
  title: string;
  description: string;
  className?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
}

const BadgeWithTooltip: React.FC<BadgeWithTooltipProps> = ({
  icon,
  alt,
  title,
  description,
  className = 'w-4 h-4',
  placement = 'top'
}) => {
  return (
    <Tooltip
      label={
        <Box>
          <Box fontWeight="bold" mb={1}>
            {title}
          </Box>
          <Box fontSize="sm" color="gray.200">
            {description}
          </Box>
        </Box>
      }
      placement={placement}
      hasArrow
      bg="gray.800"
      color="white"
      px={3}
      py={2}
      borderRadius="md"
      fontSize="sm"
      maxW="250px"
      closeOnClick={false}
      openDelay={200}
    >
      <img
        src={icon}
        alt={alt}
        title={title}
        className={`${className} cursor-help flex-shrink-0`}
      />
    </Tooltip>
  );
};

export default BadgeWithTooltip;
